export const PCExplanation = '/images/bnr_2000_700.png'
export const MobileExplanation = '/images/bnr_355_167.png'
export const GooglePlay = '/images/ja_badge_web_generic.png'
export const AppStore = '/images/badge-lrg.svg'
